(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["existing-inventory-grid"] && !Shopify.designMode) return;
  try {
    
// Initialize EmailJS (same configuration as simulator builder)
(function() {
  // Load EmailJS script
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js';
  script.onload = function() {
    emailjs.init('F--CQZB5CgvQm0GNs');
  };
  document.head.appendChild(script);
})();

document.addEventListener('DOMContentLoaded', function() {
  const sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
    
    // Set current sort value
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }
  
  // Handle build sheet email forms
  const buildSheetForms = document.querySelectorAll('.build-sheet-form');
  buildSheetForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const emailInput = form.querySelector('.email-input');
      const submitBtn = form.querySelector('.send-build-sheet-btn');
      const statusDiv = form.querySelector('.form-status');
      const productId = form.dataset.productId;
      const productName = form.dataset.productName;
      const productType = form.dataset.productType;
      const productHandle = form.dataset.productHandle;
      
      // Find matching build sheet by exact product name
      function findBuildSheet(productName) {
        const buildSheetConfig = window.buildSheetConfig || {};
        
        // Check each inventory item for exact product name match
        for (const [key, config] of Object.entries(buildSheetConfig)) {
          if (config.product_name && config.product_name.trim() === productName.trim()) {
            return {
              url: config.url || '',
              name: config.name || `${productName} Build Sheet`,
              matched_key: key
            };
          }
        }
        
        // No match found
        return {
          url: '',
          name: `${productName} Build Sheet`,
          matched_key: null
        };
      }
      
      const buildSheetData = findBuildSheet(productName);
      const buildSheetUrl = buildSheetData.url;
      const buildSheetName = buildSheetData.name;
      
      if (!emailInput.value || !emailInput.checkValidity()) {
        showFormStatus(statusDiv, 'Please enter a valid email address', 'error');
        return;
      }
      
      // Built-to-order models (Pro / Omega / Elite): use the live SC-HUB flow —
      // the same one the product pages use. It creates a real quote in the CRM
      // and emails the build sheet itself. The static-PDF config below only
      // applies to genuine one-off inventory units.
      const tierMatch = productName.match(/\b(pro|omega|elite)\b/i);
      if (!buildSheetUrl && tierMatch) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
        try {
          const tier = tierMatch[1].charAt(0).toUpperCase() + tierMatch[1].slice(1).toLowerCase();
          const hubResp = await fetch('https://ai.simcoaches.com/api/hub/lead-capture', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: emailInput.value,
              build_resume_url: window.location.href,
              page_url: window.location.href,
              build_config: {
                simulator_type: tier,
                model: productName,
                color: 'Phantom Black',
                total_price: parseFloat(form.dataset.productPrice || '0'),
                options: {},
                configured_at: new Date().toISOString()
              }
            })
          });
          if (hubResp.ok) {
            const hub = await hubResp.json();
            if (hub.build_sheet_email_sent || hub.pdf_url) {
              showFormStatus(statusDiv, 'Build sheet sent! Check your email.', 'success');
              emailInput.value = '';
              if (typeof gtag !== 'undefined') gtag('event', 'build_sheet_request', { product_name: productName });
              if (typeof scFireMetaLead === 'function') scFireMetaLead({ source: 'Ready-to-Ship Collection', category: 'Simulator Lead', value: parseFloat(form.dataset.productPrice || '0') });
              submitBtn.disabled = false;
              submitBtn.textContent = 'Send Build Sheet';
              return;
            }
          }
        } catch (err) {
          console.error('SC-HUB build sheet error:', err);
        }
        showFormStatus(statusDiv, 'Sorry, something went wrong. Please call (702) 246-2295 or email sales@simcoaches.com.', 'error');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send Build Sheet';
        return;
      }

      // Check if build sheet is configured (legacy one-off inventory units)
      if (!buildSheetUrl) {
        if (!window.buildSheetConfig || Object.keys(window.buildSheetConfig).length === 0) {
          showFormStatus(statusDiv, 'Build sheet system not configured. Please contact sales@simcoaches.com directly.', 'error');
        } else {
          showFormStatus(statusDiv, `Build sheet not found for "${productName}". Please contact sales@simcoaches.com directly.`, 'error');
        }
        return;
      }
      
      // Disable button and show loading state
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <svg class="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="10" stroke-width="4" stroke="currentColor" fill="none" opacity="0.25"/>
          <path d="m15 12 1 1m-1-1V8a4 4 0 0 0-8 0v4m1-1 1-1" stroke-width="4" stroke="currentColor" opacity="0.75"/>
        </svg>
        Sending...
      `;
      
      // Check if EmailJS is loaded
      if (typeof emailjs === 'undefined') {
        showFormStatus(statusDiv, 'Please wait a moment and try again.', 'error');
        submitBtn.disabled = false;
        submitBtn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c0 .089.048.17.126.22L7.5 8.793a1 1 0 0 0 1 0l6.374-3.28A.25.25 0 0 0 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11ZM15 6.954L8.978 9.86a2 2 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z"/>
          </svg>
          Send Build Sheet
        `;
        return;
      }
      
      // Debug info
      console.log(`🔍 Looking for build sheet for product: "${productName}"`);
      console.log(`🔧 Available configurations:`, window.buildSheetConfig);
      
      // Show what we're comparing against
      if (window.buildSheetConfig) {
        Object.entries(window.buildSheetConfig).forEach(([key, config]) => {
          console.log(`🔎 ${key}: "${config.product_name}" vs "${productName}" = ${config.product_name?.trim() === productName.trim()}`);
        });
      }
      
      console.log(`✅ Match found: ${buildSheetData.matched_key || 'NONE'}`);
      console.log(`📄 Using build sheet: ${buildSheetName} -> ${buildSheetUrl}`);
      
      // Submit form data using EmailJS
      const emailParams = {
        to_email: emailInput.value,
        cc_email: 'sales@simcoaches.com',
        customer_email: emailInput.value,
        sales_email: 'sales@simcoaches.com',
        product_name: productName,
        product_id: productId,
        build_sheet_name: buildSheetName,
        build_sheet_url: buildSheetUrl,
        request_type: 'Build Sheet Request',
        source: 'Existing Inventory Page',
        timestamp: new Date().toLocaleString(),
        page_url: window.location.href,
        has_build_sheet: buildSheetUrl ? 'Yes' : 'No'
      };
      
      // Send using EmailJS (same service as simulator builder)
      emailjs.send('service_vqm699t', 'template_4zeh2jq', emailParams)
        .then(response => {
          console.log('Build sheet request sent successfully:', response);
          showFormStatus(statusDiv, 'Build sheet sent! Check your email.', 'success');
          emailInput.value = '';
          
          // Track conversion event
          if (typeof gtag !== 'undefined') {
            gtag('event', 'build_sheet_request', {
              product_name: productName,
              customer_email: emailInput.value
            });
          }
        })
        .catch(error => {
          console.error('EmailJS error:', error);
          showFormStatus(statusDiv, 'Sorry, there was an error. Please try again.', 'error');
        })
      .finally(() => {
        // Reset button
        submitBtn.disabled = false;
        submitBtn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c0 .089.048.17.126.22L7.5 8.793a1 1 0 0 0 1 0l6.374-3.28A.25.25 0 0 0 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11ZM15 6.954L8.978 9.86a2 2 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z"/>
          </svg>
          Send Build Sheet
        `;
      });
    });
  });
  
  function showFormStatus(statusDiv, message, type) {
    statusDiv.textContent = message;
    statusDiv.className = `form-status ${type}`;
    statusDiv.style.display = 'block';
    
    // Hide status after 5 seconds
    setTimeout(() => {
      statusDiv.style.display = 'none';
    }, 5000);
  }
});

  } catch(e) { console.error(e); }
})();
})();
